import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { DefaultDataService } from './default-data.service';
import { WebAPIResult } from './employee.service';
import { EventService } from './event.service';

export class CustomerSettingsData {
  AutoLogoutTime = 5;
  PreSessionDelay = 3;
  PostSessionDelay = 3;
  DetailsTabByDefault = true;

  aptStateBooked = '';
  aptStateAttended = '';
  aptStatePaid = '';
  aptStateInProgress = '';
  aptStateCompleted = '';

  AllowOnlineClientRegistration = false;
  DisableOnlineBookings = false;
  DisableOnlineBookingsIfNoCredit = false;
  EnforceOneDailyAppointment = false;
  HidePurchaseHistory = false;
  NewOnlineClientsCanBookImmediately = false;
  OnlineReservationVerifyEmails = false;
  OnlineReservationMaxSessionTime = 0;
  OnlineReservationMinMinutesBeforeCanBook = 0;
  OnlineReservationWelcomeText = '';
  OnlineReservationSkinTypeInformation = '';
  OnlineReservationSkinTypeInfoFile = '';
  OnlineReservationSkinTypeInfoFileName = '';
  OnlineReservationIcon = '';
  OnlineReservationMinAge = 18;
  OnlineReservationRequireDob = false;
  OnlineReservationRequireMobile = false;
  OnlineReservationRequireSkinType = false;
  OnlineReservationRequirePhoto = false;
  OnlineReservationPasswordRequireSymbol = true;
  OnlineReservationPasswordRequireNumber = true;
  OnlineReservationPasswordRequireUppercaseLetter = true;
  OnlineReservationRegisterAsNewClientByDefault = false;
  OnlineReservationSlotInterval = 5;
  OnlineClientRegistrationDisclaimer = '';

  Alias = '';

  EOSEODReportEmail = '';
  SendEODToCustomer = false;
  SendEOSToCustomer = false;
  SendDailyTotalsToCustomer = false;
  SendEODToBranch = false;
  SendEOSToBranch = false;
  HourToSendEOSEODReport = 23;

  SendAppointmentRemindersByEmail = true;
  EmailReminderHoursInAdvance = 24;

  // Used internally
  EOSEODReportEmailArray: string[] = [];

  ClientRequireDOB: boolean = false;
  ClientRequireMobile: boolean = false;
  ClientRequireEmail: boolean = false;
  ClientRequireSkinType: boolean = false;
  ClientRequireIDCheck: boolean = false;
  DisplayRota: boolean = false;
  UseInsufficientCreditCalculator:boolean = false;
  OrderResourcesByRunningTotals: boolean = false;
  LimitAppointmentCancellation: boolean = true;
  LimitAppointmentCancellationTime: number = 30;
  DisableSafetyPolicyOverride: boolean = false;
  DisableSkinTypeOverride: boolean = false;
  LimitPOSAptSale: boolean = true;
  LimitPOSAptSaleTime: number = 30;
  EnableEReceipts: boolean = true;
  IncludeTransactionList: boolean = false;
  SetReportingPassword: boolean = false;
  ReportingPassword: string = '';
  ShowOnlineAvailabilityInAptBook: boolean = false;
  AllowCreditsInPlaceOfDeposit: boolean = true;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerSettingsService {
  url = '/api/BackOffice/CustomerSettings';

  constructor(private http: HttpClient, private defaultData: DefaultDataService, private events: EventService) {
    console.log('Starting Customer Settings Service');
  }

  public GetCustomerSettings(): Observable<CustomerSettingsData> {
    return this.http.get<CustomerSettingsData>(this.url);
  }

  public SaveCustomerSettings(customerSettings: CustomerSettingsData): Observable<WebAPIResult> {
    return this.http.post<WebAPIResult>(this.url, customerSettings).pipe(
      take(1),
      catchError((e) => {
        const d: WebAPIResult = e as WebAPIResult;
        return of(d);
      }),
      tap((r) => {
        console.log(`Data Save Result: ${r}`);

        // Update System
        this.defaultData.defData.customerSettings = customerSettings;
        this.events.DefaultDataChanged(this.defaultData.defData);

        const d: WebAPIResult = r as WebAPIResult;
        return d;
      })
    );
  }
}
